import React from "react"
import ImageGridItem from "./ImageGridItem"

export default ({ images }) => {
  return (
    <div className="portfolio-grid">
      {images.map((item, i) => (
        <ImageGridItem key={item.node.id} item={item} index={i} />
      ))}
    </div>
  )
}
